(function () {
  if (window.__sprSampleProductsInitialized) return;
  window.__sprSampleProductsInitialized = true;

  function sprEscapeHtml(value) {
    return String(value || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;");
  }

  function sprToAbsoluteUrl(url) {
    if (!url) return "";
    if (url.startsWith("//")) return window.location.protocol + url;
    if (url.startsWith("http://") || url.startsWith("https://")) return url;
    return window.location.origin + url;
  }

  async function sprFetchCollectionProducts(handle) {
    const all = [];
    const limit = 250;
    let page = 1;
    let keepGoing = true;

    while (keepGoing && page <= 20) {
      const response = await fetch(`/collections/${handle}/products.json?limit=${limit}&page=${page}`, {
        credentials: "same-origin"
      });

      if (!response.ok) {
        throw new Error("Collection products could not be loaded.");
      }

      const data = await response.json();
      const products = Array.isArray(data.products) ? data.products : [];

      all.push.apply(all, products);

      if (products.length < limit) {
        keepGoing = false;
      } else {
        page += 1;
      }
    }

    return all;
  }

  document.addEventListener("DOMContentLoaded", function () {
    const drawer = document.querySelector("[data-spr-root]");
    const backdrop = document.querySelector("[data-spr-backdrop]");

    if (!drawer || !backdrop) return;

    const config = {
      collectionHandle: drawer.getAttribute("data-spr-collection") || "",
      sampleBoxHandle: drawer.getAttribute("data-spr-sample-box-handle") || "",
      sampleBoxVariantId: drawer.getAttribute("data-spr-sample-box-variant-id") || "",
      maxSamples: Number(drawer.getAttribute("data-spr-max") || 3),
      cartUrl: drawer.getAttribute("data-spr-cart-url") || "/cart"
    };

    if (!config.collectionHandle || !config.sampleBoxVariantId) return;

    const closeButtons = drawer.querySelectorAll("[data-spr-close]");
    const listEl = drawer.querySelector("[data-spr-list]");
    const selectedListEl = drawer.querySelector("[data-spr-selected-list]");
    const selectedEmptyEl = drawer.querySelector("[data-spr-selected-empty]");
    const countEl = drawer.querySelector("[data-spr-count]");
    const searchInput = drawer.querySelector("[data-spr-search]");
    const errorEl = drawer.querySelector("[data-spr-error]");
    const submitBtn = drawer.querySelector("[data-spr-add-to-cart]");

    const selected = new Map();

    let allProducts = [];
    let filteredProducts = [];
    let isLoadingProducts = false;
    let productsLoaded = false;
    let isSubmitting = false;

    function sprShowError(message) {
      if (!errorEl) return;
      errorEl.hidden = false;
      errorEl.textContent = message;
    }

    function sprClearError() {
      if (!errorEl) return;
      errorEl.hidden = true;
      errorEl.textContent = "";
    }

    function sprOpenDrawer(trigger) {
      drawer.classList.add("spr-is-open");
      backdrop.classList.add("spr-is-open");
      drawer.setAttribute("aria-hidden", "false");
      document.documentElement.classList.add("spr-lock");
      document.body.classList.add("spr-lock");
      sprLoadProductsIfNeeded();
      sprAddCurrentProductFromTrigger(trigger);
    }

    function sprCloseDrawer() {
      drawer.classList.remove("spr-is-open");
      backdrop.classList.remove("spr-is-open");
      drawer.setAttribute("aria-hidden", "true");
      document.documentElement.classList.remove("spr-lock");
      document.body.classList.remove("spr-lock");
      sprClearError();
    }

    function sprNormalizeProduct(product) {
      const firstVariant = Array.isArray(product.variants) && product.variants.length ? product.variants[0] : {};
      const imageSrc =
        product.image && product.image.src
          ? product.image.src
          : Array.isArray(product.images) && product.images.length
          ? product.images[0].src || product.images[0]
          : "";

      return {
        id: String(product.id),
        variantId: String(firstVariant.id || product.id),
        handle: product.handle || "",
        title: product.title || "",
        url: `/products/${product.handle}`,
        image: sprToAbsoluteUrl(imageSrc),
        sku: firstVariant && firstVariant.sku ? firstVariant.sku : "",
        available: product.available !== false
      };
    }

    function sprRenderSelected() {
      const items = Array.from(selected.values());

      if (countEl) {
        countEl.textContent = `${items.length}/${config.maxSamples}`;
      }

      if (selectedEmptyEl) {
        selectedEmptyEl.hidden = items.length > 0;
      }

      if (!items.length) {
        selectedListEl.innerHTML = "";
      } else {
        selectedListEl.innerHTML = items
          .map(function (item) {
            return `
              <div class="spr-selected-card">
                <button
                  type="button"
                  class="spr-selected-remove"
                  data-spr-remove-selected="${sprEscapeHtml(item.id)}"
                  aria-label="Remove"
                >&times;</button>
                <div class="spr-selected-image">
                  ${item.image ? `<img src="${sprEscapeHtml(item.image)}" alt="${sprEscapeHtml(item.title)}" loading="lazy">` : ""}
                </div>
                <div class="spr-selected-name">${sprEscapeHtml(item.title)}</div>
              </div>
            `;
          })
          .join("");
      }

      sprRenderList();
    }

    function sprRenderList() {
      if (isLoadingProducts) {
        listEl.innerHTML = `<div class="spr-loading">Loading products...</div>`;
        return;
      }

      if (!filteredProducts.length) {
        listEl.innerHTML = `<div class="spr-no-results">No products found.</div>`;
        return;
      }

      const isLimitReached = selected.size >= config.maxSamples;

      listEl.innerHTML = filteredProducts
        .map(function (item) {
          const alreadySelected = selected.has(item.id);
          const disableAdd = !alreadySelected && isLimitReached;
          const buttonText = alreadySelected ? "Geselecteerd" : "Toevoegen";

          return `
            <div class="spr-item">
              <div class="spr-item-image">
                ${item.image ? `<img src="${sprEscapeHtml(item.image)}" alt="${sprEscapeHtml(item.title)}" loading="lazy">` : ""}
              </div>
              <div class="spr-item-title">${sprEscapeHtml(item.title)}</div>
              <div class="spr-item-actions">
                <button
                  type="button"
                  class="spr-item-btn ${alreadySelected ? "spr-is-selected" : ""}"
                  data-spr-select="${sprEscapeHtml(item.id)}"
                  ${disableAdd ? "disabled" : ""}
                >
                  ${buttonText}
                </button>
              </div>
            </div>
          `;
        })
        .join("");
    }

    function sprApplySearch() {
      const keyword = (searchInput.value || "").trim().toLowerCase();

      filteredProducts = allProducts.filter(function (item) {
        if (!keyword) return true;
        return (
          item.title.toLowerCase().includes(keyword) ||
          item.handle.toLowerCase().includes(keyword) ||
          (item.sku || "").toLowerCase().includes(keyword)
        );
      });

      sprRenderList();
    }

    function sprAddSample(item) {
      sprClearError();

      if (selected.has(item.id)) return;

      if (selected.size >= config.maxSamples) {
        sprShowError(`Je kunt maximaal ${config.maxSamples} samples kiezen. Verwijder eerst een sample.`);
        return;
      }

      selected.set(item.id, item);
      sprRenderSelected();
    }

    function sprRemoveSample(id) {
      selected.delete(String(id));
      sprRenderSelected();
      sprClearError();
    }

    function sprAddCurrentProductFromTrigger(trigger) {
      if (!trigger) return;

      const productId = trigger.getAttribute("data-spr-current-product-id");
      const variantId = trigger.getAttribute("data-spr-current-variant-id") || productId;
      if (!productId) return;

      const currentItem = {
        id: String(productId),
        variantId: String(variantId),
        handle: trigger.getAttribute("data-spr-current-product-handle") || "",
        title: trigger.getAttribute("data-spr-current-product-title") || "",
        url: trigger.getAttribute("data-spr-current-product-url") || "",
        image: sprToAbsoluteUrl(trigger.getAttribute("data-spr-current-product-image") || ""),
        sku: trigger.getAttribute("data-spr-current-product-sku") || "",
        available: true
      };

      if (!selected.has(currentItem.id)) {
        sprAddSample(currentItem);
      }
    }

    async function sprLoadProductsIfNeeded() {
      if (productsLoaded || isLoadingProducts) return;

      isLoadingProducts = true;
      sprRenderList();

      try {
        const rawProducts = await sprFetchCollectionProducts(config.collectionHandle);

        allProducts = rawProducts
          .map(sprNormalizeProduct)
          .filter(function (item) {
            // Filter out Seramik and Wandpanel products
            var titleLower = (item.title || "").toLowerCase();
            var handleLower = (item.handle || "").toLowerCase();
            
            var excludedKeywords = ["seramik", "seramic", "ceramic", "wandpanel", "wand panel", "wall panel", "wandpaneel"];
            
            for (var i = 0; i < excludedKeywords.length; i++) {
              if (titleLower.indexOf(excludedKeywords[i]) !== -1 || handleLower.indexOf(excludedKeywords[i]) !== -1) {
                return false;
              }
            }
            
            return item.handle && item.handle !== config.sampleBoxHandle;
          });

        const uniqueMap = new Map();
        allProducts.forEach(function (item) {
          uniqueMap.set(item.id, item);
        });

        allProducts = Array.from(uniqueMap.values());
        filteredProducts = allProducts.slice();
        productsLoaded = true;
      } catch (error) {
        listEl.innerHTML = `<div class="spr-no-results">Producten konden niet worden geladen.</div>`;
      } finally {
        isLoadingProducts = false;
        sprRenderList();
      }
    }

    function sprBuildCartItems() {
      const items = Array.from(selected.values());
      
      if (items.length === 0) return [];
      
      // All samples are added as ONE Sample Box product (€9.95 total)
      // Store all selected samples as properties
      const sampleProps = {
        "_is_sample": "true",
        "_sample_count": String(items.length)
      };
      
      items.forEach(function (item, index) {
        sampleProps["_sample_" + (index + 1) + "_title"] = item.title;
        sampleProps["_sample_" + (index + 1) + "_image"] = item.image;
        sampleProps["_sample_" + (index + 1) + "_handle"] = item.handle;
        sampleProps["_sample_" + (index + 1) + "_id"] = item.id;
      });
      
      return [{
        id: Number(config.sampleBoxVariantId), // Sample Box variant ID
        quantity: 1,
        properties: sampleProps
      }];
    }

    async function sprAddSamplesToCart() {
      sprClearError();

      if (!selected.size) {
        sprShowError("Voeg minimaal 1 sample toe.");
        return;
      }

      if (isSubmitting) return;
      isSubmitting = true;
      submitBtn.disabled = true;

      const originalText = submitBtn.textContent;
      submitBtn.textContent = "Bezig...";

      try {
        const cartItems = sprBuildCartItems();
        
        const response = await fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
          },
          credentials: "same-origin",
          body: JSON.stringify({
            items: cartItems
          })
        });

        if (!response.ok) {
          throw new Error("Cart add failed");
        }

        submitBtn.textContent = "Samples toegevoegd";

        setTimeout(function () {
          window.location.href = config.cartUrl;
        }, 300);
      } catch (error) {
        submitBtn.textContent = originalText;
        sprShowError("Er is een fout opgetreden. Probeer opnieuw.");
      } finally {
        isSubmitting = false;
        submitBtn.disabled = false;
      }
    }

    document.addEventListener("click", function (event) {
      const openTrigger = event.target.closest("[data-spr-open]");
      const closeTrigger = event.target.closest("[data-spr-close]");
      const selectTrigger = event.target.closest("[data-spr-select]");
      const removeTrigger = event.target.closest("[data-spr-remove-selected]");

      if (openTrigger) {
        event.preventDefault();
        sprOpenDrawer(openTrigger);
        return;
      }

      if (closeTrigger || event.target === backdrop) {
        event.preventDefault();
        sprCloseDrawer();
        return;
      }

      if (selectTrigger) {
        event.preventDefault();
        const productId = String(selectTrigger.getAttribute("data-spr-select"));
        const item = allProducts.find(function (product) {
          return product.id === productId;
        });

        if (!item) return;

        if (selected.has(productId)) {
          sprRemoveSample(productId);
        } else {
          sprAddSample(item);
        }
        return;
      }

      if (removeTrigger) {
        event.preventDefault();
        sprRemoveSample(removeTrigger.getAttribute("data-spr-remove-selected"));
      }
    });

    if (searchInput) {
      searchInput.addEventListener("input", sprApplySearch);
    }

    if (submitBtn) {
      submitBtn.addEventListener("click", sprAddSamplesToCart);
    }

    closeButtons.forEach(function (button) {
      button.addEventListener("click", sprCloseDrawer);
    });

    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape" && drawer.classList.contains("spr-is-open")) {
        sprCloseDrawer();
      }
    });

    sprRenderSelected();
    sprRenderList();
  });
})();